import React, { Fragment, useEffect, useRef, useState } from "react";
import { Chart, Axis, Tooltip, Annotation, Line, GComponents, Schema, Legend } from 'bizcharts';
import { connect } from "react-redux";
// import {getIndicators} from "actions/IndicatorsActions";
// import Spinner from "../../common/Spinner";
// import Plot from 'react-plotly.js';
// import 'bootstrap/dist/css/bootstrap.min.css';


// reactstrap components
import {
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Card,
    CardTitle,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";

import {
    clearData,
    clearPrevious,
    removePlotPoint,
    deletePreviousFilter,
    setActivePlot,
    getData, getHospital
} from "actions";

import { DataView } from '@antv/data-set';
import BoxPlot from "components/indicatorsComponets/Plot/BoxPlot";
import MapPlot from "components/indicatorsComponets/Plot/MapPlot";
import IconTile from 'components/indicatorsComponets/IconTile';
import IndicatorDescription from './IndicatorDescription';
import {setIndicator} from "../../../../actions";

const {
    Canvas,
} = GComponents;

const Benchmark = ({
    PlotData: { plot_data, loading, hide_data, stats, active_plot, refresh },
    getData, clearData, deletePreviousFilter, clearPrevious, getHospital,
    Filters: { start_date, end_date, available_filters, refresh_filter, previous_filter },
    removePlotPoint, setActivePlot,setIndicator,
    Indicators: { available_indicators, active_indicators }
}) => {


    const [displayData, SetData] = useState([]);
    const [normalisedData, SetNormalisedData] = useState([]);
    const [index, setIndex] = useState(0);
    const dv = useRef(null)
        const valueConvert = (val, prec=2) => {
        if(typeof val === typeof 1){
            if(getValueType() === " dni")
                prec = 0;
            return (Number(val).toFixed(prec)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",") + getValueType()

        }
        return "Brak Danych"
      }
   useEffect(()=>{setIndicator("Wskaźnik zyskowności netto");},[])
    const getDataRuqest = () => {
        if (active_indicators.length > 0) {
            getData(active_indicators, previous_filter, start_date, end_date);
        }
        if (active_indicators.length !== Object.keys(plot_data).length) {
            let keys = Object.keys(plot_data);
            let difference = keys.filter(x => !active_indicators.includes(x));
            difference.map(x => {
                if(previous_filter.hasOwnProperty(x))
                    deletePreviousFilter({x:"none"},"none","benchmark68");
                removePlotPoint(x)
            });

        }
    };

    useEffect(() => {
        const asyncWrapper = async () => {
            getDataRuqest()
        }
        asyncWrapper()
    }, [start_date, end_date]);

    useEffect(() => {
        const asyncWrapper = async () => {
            getDataRuqest()
        }
        if (active_indicators.length !== 0 && (active_indicators.length > Object.keys(plot_data).length)) {
            asyncWrapper()
        }

        if (active_indicators.length === 0) {
            clearData();
            clearPrevious();
            SetData([]);
        }

    }, [active_indicators]);

    useEffect(() => {
        const asyncWrapper = async () => {
            getDataRuqest()
        }
        if (active_indicators.length !== 0) {
            asyncWrapper()
        }

    }, [refresh_filter]);

    useEffect(() => { getHospital(); }, [])

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    //UseEffect ustawie aktywny wykres na podstawie dostarczonego id z aktywnych wskaźników
    useEffect(() => {
        if (active_indicators.length !== Object.keys(plot_data).length) {
            let keys = Object.keys(plot_data);
            let difference = active_indicators.filter(x => !keys.includes(x));
            if (difference.includes(Object.keys(plot_data)[index])) {
                setIndex(0)
                setActivePlot(active_indicators[0]);
            }
        } else
            setActivePlot(active_indicators[index]);
    }, [index, plot_data]);


    useEffect(() => {
        // SetData(plot_data.filter(dataPoint => !hide_data.includes(dataPoint.nazwa_regionu)))
        if (!hide_data.hasOwnProperty(active_plot) || !plot_data.hasOwnProperty(active_plot)) {

            if (index === Object.keys(plot_data).length && Object.keys(plot_data).length !== 0) {
                setIndex(index - 1);
            }
            return;
        }

        const filtered = { ...Object.keys(plot_data) };
        filtered[active_plot] = calculateData();

        SetNormalisedData(NormaliseData(filtered[active_plot]));
        SetData(filtered);

        if (index === Object.keys(plot_data).length && Object.keys(plot_data).length !== 0) {
            setIndex(index - 1);
        }
    }, [plot_data, hide_data, refresh, active_plot, active_indicators]);
    //Normlaizacja danych do zakresu 0,1 potrzebne do rysowania mapy
    const NormaliseData = (data) => {
        let tmpData = data
        tmpData = tmpData.filter(i => {
            if (i.hasOwnProperty("nazwa_regionu")) {

                if (i.nazwa_regionu !== "Polska")
                    return i
            }

        })

        const max = Math.max(...tmpData.map(i => i.median));
        const min = Math.min(...tmpData.map(i => i.median));
        return tmpData.map(i => { return { nazwa_regionu: i.nazwa_regionu, median: i.median, normalisedIndicator: (i.median - min) / (max - min) } })
    };

    // Filtrowanie danych do wyświetlania a następnie wyliczanie danych statystycznych na ich podstawie
    const calculateData = () => {
        let data = plot_data[active_plot].filter(key => !hide_data[active_plot].includes(key.nazwa_regionu));
        data = data.filter(x => !active_indicators.includes(x));

        const d = new DataView().source(data)

        d.transform({
            type: 'map',
            callback: obj => {

                obj.range = [obj.low, obj.q1, obj.median, obj.q3, obj.high];
                return obj;
            }
        }
        )
        return d.rows;
    };

    // Ustwainie osi y dla danych statysnczych w zależnosci od wartości wskaźników


    const getValueType = () => {
        let indicator = available_indicators.filter(indicator => indicator.nazwa === active_plot)
        if (indicator[0]) {
            if (indicator[0].value_type === null) {
                return ""
            }
            else {
                return indicator[0].value_type
            }
        }
        return ""


    }

    const getNoFilterId = () =>{
        if(Object.keys(available_filters.length>0)){
          let NoFilter =  available_filters.filter(x=>x.nazwa === "wojewodztwo")[0];
          if(NoFilter){
              return NoFilter.id
          }

        }

    }


    const getActiveFiltersName = () =>{
        if(previous_filter.hasOwnProperty(active_plot)) {
            const active_filter = previous_filter[active_plot]
            if(active_filter.hasOwnProperty(getNoFilterId())){
                return ""
            }
           const results = Object.entries(active_filter).map(filter=>{
               const found = available_filters.filter(x=>x.id == filter[0])[0]
               if(found.pola ==="opk_select"){
                   if (filter[1] !=="none"){
                       return "Nr OPK: "+filter[1]
                   }
               }
               else{
                   const subfilter = JSON.parse(found.pola).filter(x=>x[0]==filter[1])[0]
                   if(subfilter && subfilter.length ===2){
                       return subfilter[1]
                   }

               }
               return ""
           })
            let return_string =''
            results.forEach(item=>{
                if(item){
                    return_string = return_string + item + ", "
                }
            })
            if(return_string.length > 2){
                return_string = return_string.substring(0, return_string.length - 2)
            }
            return return_string

        }
        else
            return ""


    }

    return (
        <>{!loading && Object.keys(plot_data).length !== 0 ? <>
            <Row><Col>
                <Card>
                    <CardBody>
                        <div className="nav-tabs-navigation mb-0" style={{borderBottom:"none"}}>
                            <div className="nav-tabs-wrapper">
                                <Nav id="tabs" role="tablist" tabs >
                                    {active_indicators.length > 0 && active_indicators.map((indicator_name, idx) => {
                                        return(
                                            <NavItem key={indicator_name+idx*2}>
                                                <NavLink
                                                    aria-expanded={index === idx}
                                                    data-toggle="tab"
                                                    // href="#pablo"
                                                    role="tab"
                                                    className={index === idx ? "active wskaznikiPanel" : ""}
                                                    onClick={() => setIndex(idx)}
                                                    key={indicator_name+idx}
                                                    style={{cursor:"pointer"}}
                                                >
                                                    {`${indicator_name}`}
                                                </NavLink>
                                            </NavItem>
                                        )
                                    })}
                                </Nav>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col></Row>
            <Row>
                <Col md='9'>
                    <Card>
                        <CardBody>
                            <MapPlot
                                plot_data={normalisedData} value_type={getValueType()} name={active_plot} 
                                start={start_date} end={end_date} title={getActiveFiltersName()} />
                        </CardBody>
                    </Card>
                </Col>
                <Col md='3'>
                    <IconTile name='Twój wskaźnik' value={plot_data[active_plot]?valueConvert(plot_data[active_plot][0]["wartosc_wskaznika"]):"brak wartości"} icon='far fa-chart-bar' color={{icon:'wskazniki', text: 'black'}}/>
                    <IndicatorDescription />
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <TabContent
                        className="text-center"
                        id="my-tab-content"
                        activeTab={index}
                    >
                        {Object.keys(displayData).length > 0 && Object.keys(plot_data).map((indicatorKey, id) => {
                            return (
                                <TabPane key={id} tabId={id} role="tabpanel">
                                    <BoxPlot displayData={displayData[indicatorKey]} loading value_type={getValueType()} name={active_plot} title={getActiveFiltersName()} start={start_date} end={end_date} />
                                </TabPane>
                            )
                        })}
                    </TabContent>
                    {/* <div className="nav-tabs-navigation">
                        <div className="nav-tabs-wrapper">
                            <Nav id="tabs" role="tablist" tabs>
                                {active_indicators.length > 0 && active_indicators.map((indicator_name, idx) => {
                                    return (
                                        <NavItem>
                                            <NavLink
                                                aria-expanded={index === idx}
                                                data-toggle="tab"
                                                // href="#pablo"
                                                role="tab"
                                                className={index === idx ? "active" : ""}
                                                onClick={() => setIndex(idx)}
                                            >
                                                {`${indicator_name}`}
                                            </NavLink>
                                        </NavItem>
                                    )
                                })}
                            </Nav>
                        </div>
                    </div> */}
                </CardBody>
            </Card></> : <Card> <CardHeader>
                <CardTitle className='text-center h4'>Wybierz wskaźniki, aby wyświetlić wykres</CardTitle>
            </CardHeader>
            <CardBody>
                <Row className='text-center'>
                    <Col className='ml-auto mr-auto'>
                        {/*<Spinner/>*/}
                    </Col>
                </Row>
            </CardBody>
        </Card>}
        </>
    )

};


// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData,
    Indicators: state.Indicators,
    Filters: state.Filters,

});


export default connect(mapStateToProps, {
    setActivePlot,
    clearData,
    getData,
    deletePreviousFilter,
    removePlotPoint,
    clearPrevious,
    getHospital,
    setIndicator
})(Benchmark);


